<template>
    <div class="nav-wrapper">
        <headroom>
            <slot></slot>
        </headroom>
    </div>
</template>

<script>
import {headroom} from 'vue-headroom';

headroom.computed.style = () => '';

export default {
    name: "Headroom",

    components: {
        headroom
    }
}
</script>
